module.exports = __webpack_public_path__ + "static/media/employmentImg.cc860e08.svg";